import {Action} from '@ngrx/store';

export enum LoaderActionTypes {
    Start = '[Loader] Start Loading',
    Stop = '[Loader] Stop Loading'
}

export class StartLoadingAction implements Action {
    readonly type = LoaderActionTypes.Start;
}

export class StopLoadingAction implements Action {
    readonly type = LoaderActionTypes.Stop;
}

export type Actions
    = StartLoadingAction
    | StopLoadingAction;
